import script from "./PhoneDirectory.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneDirectory.vue?vue&type=script&setup=true&lang=js"

import "./PhoneDirectory.vue?vue&type=style&index=0&id=c5632748&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5632748"]])

export default __exports__